import DefaultTheme from '../themes/default';

const Theme = DefaultTheme as ITheme;

export default Theme;
